







import { Component, Mixins} from "vue-property-decorator";
import { DialogSelectableMixin } from "../../system/selectors/mixins";

@Component
export default class DocumentDepartmentGroupDialogSelector extends Mixins(DialogSelectableMixin) {
}
